import styled from "styled-components";
import { CSSProperties } from "react";

export const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 200px) and (max-width: 399px) {
    min-height: 400px;
    text-align: center;
  }

  @media (min-width: 400px) and (max-width: 799px) {
    min-height: 400px;
    text-align: center;
  }

  @media (min-width: 800px) {
    min-height: 400px;
    text-align: center;
  }
`;

export const ContainerTitulo = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 1.6% 90%;
  justify-content: center;
  align-items: center;
`;
export const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 70% 95%;

  justify-content: center;
  align-items: center;
`;
export const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;

  grid-template: 10% 90% / auto;
`;

export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

export const ContainerItems = styled.div`
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: linear-gradient(135deg, #f9f9f9, #ffffff);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
`;

export const Items = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  strong {
    font-weight: bold;
    color: #555;
  }
`;

export const Icon = styled.span`
  font-size: 16px;
  color: #666;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;
